import React from "react";

export function CircularProgress({ value = 0, size = 120, stroke = 10, label, sublabel, gradient = true }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const dash = (value / 100) * circ;
  const color = value >= 85 ? "#0F3D34" : value >= 70 ? "#C9A66B" : value >= 55 ? "#5F7F77" : "#C5B0BA";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={`grad-${size}-${Math.round(value)}`} x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#0F3D34" />
            <stop offset="100%" stopColor="#C9A66B" />
          </linearGradient>
        </defs>
        <circle cx={size/2} cy={size/2} r={radius} stroke="#EFE0E5" strokeWidth={stroke} fill="none" />
        <circle
          cx={size/2}
          cy={size/2}
          r={radius}
          stroke={gradient ? `url(#grad-${size}-${Math.round(value)})` : color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={`${dash} ${circ}`}
          strokeLinecap="round"
          style={{ transition: "stroke-dasharray 1s ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-3xl font-semibold text-[#332D38]" data-testid="compat-value">{Math.round(value)}<span className="text-lg text-[#8A7E91]">%</span></span>
        {label && <span className="text-[0.7rem] uppercase tracking-wider text-[#8A7E91] mt-0.5">{label}</span>}
        {sublabel && <span className="text-xs text-[#8A7E91]">{sublabel}</span>}
      </div>
    </div>
  );
}

export function LinearScore({ value, label, icon }) {
  const color = value >= 85 ? "from-[#082A24] to-[#0F3D34]" : value >= 70 ? "from-[#2A5950] to-[#082A24]" : value >= 55 ? "from-[#3D5750] to-[#082A24]" : "from-slate-300 to-slate-400";
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="flex items-center gap-1.5 text-[#332D38] font-medium">{icon}{label}</span>
        <span className="font-semibold text-[#C9A66B]">{value}%</span>
      </div>
      <div className="h-2 rounded-full bg-[#EDE5D2] overflow-hidden">
        <div className={`h-full rounded-full bg-gradient-to-r ${color} transition-all duration-700`} style={{ width: `${value}%` }} />
      </div>
    </div>
  );
}
